import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Observable } from 'rxjs';
import { EnvironmentConfigService } from 'src/app/services/environment-config-service/environment-config-service';
import { SessionService } from 'src/app/services/session-service/session-service';

@Injectable({
	providedIn: 'root'
})
export class LoginGuard {
	constructor(
		private authService: AuthService,
		private router: Router,
		private _EnvironmentConfigService: EnvironmentConfigService,
		private sessionService: SessionService,
	) { }

	canLoad():
		| boolean
		| UrlTree
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree> {
		return this.allowLogin();
	}

	private async allowLogin(): Promise<boolean | UrlTree> {
		const appConfig = await this._EnvironmentConfigService.EnsureNetworkConfiguration();
		if (!appConfig) {
			return this.redirectToSignedOut();
		}

		// Presence of a stored user is not a session. Once the bearer TTL has
		// passed, the welcome page must not load with a dead token.
		if (await this.authService.accessTokenExpired()) {
			return this.redirectToSignedOut();
		}

		this.sessionService.ensureIdleTimeoutInitialized();
		await this.authService.init();
		return true;
	}

	private async redirectToSignedOut(): Promise<UrlTree> {
		await this.authService.clearUserData(false);
		const path = this._EnvironmentConfigService.Platform === 'android' ? '/landing' : '/login';
		return this.router.parseUrl(path);
	}
}
